import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, Tipo } from '../components/';


interface ICampoCAPProps extends Dati.IBaseProps {
    Valore: string;
    Disabilitato?: boolean
    Comune?: string
    Provincia?: string
}

export class CampoCAP extends BasePureComponent<ICampoCAPProps, {}> {
    private _Comuni: Dati.CComune[];
    private _ListaCAP: Dati.TDictTipo = {};

    constructor(props: any) {
        super(props);
        this._Comuni = require('./Dati/comuni.json');
    }

    private PopolaCap() {
        this._ListaCAP = {};
        let comuniApp: Dati.CComune[] = this._Comuni;
        if (this.props.Comune != undefined && this.props.Comune != "") {
            let comune: string = this.props.Comune;
            comuniApp = comuniApp.filter(c => c.nome == comune);
        }
        if (this.props.Provincia != undefined && this.props.Provincia != "") {
            let provincia: string = this.props.Provincia;
            comuniApp = comuniApp.filter(c => c.sigla == provincia);
        }
        for (let i: number = 0; i < comuniApp.length; i++) {
            for (let y: number = 0; y < comuniApp[i].cap.length; y++) {
                this._ListaCAP[comuniApp[i].cap[y]] = new Dati.CTipo(comuniApp[i].cap[y], comuniApp[i].cap[y]);
            }
        }
    }

    public render() {
        this.PopolaCap();
        return <Tipo Dati={this._ListaCAP} ID_ChiaveString={this.props.Valore} Campo={this.props.Name} OnAggiorna={this.props.OnChange} OnBlur={this.props.OnBlur} Disabilitato={this.props.Disabilitato} TradValori={false} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/CampoCAP.tsx